/**
 * Custom hook to handle sorting and filtering of item details.
 * @param {Array} items - The list of items to sort and filter.
 * @param {Function} filterFn - The filtering function.
 * @param {Function} sortFn - The sorting function.
 * @returns {Object} - Contains sorted and filtered items, and methods to update sorting and filtering.
 */

import { useDispatch } from 'react-redux';
import { sortSetItemDetails} from 'src/utils/util';
import { 
    sortProductDetails as sortEquityProductDetails,
} from 'src/pages/equity/redux/actions';
import { 
    sortProductDetails as sortConsignmentAddProductDetails,
} from 'src/pages/consignmentAdd/redux/actions/index';
import { 
    sortProductDetails, 
} from 'src/pages/scheduleSurgery/redux/actions/index';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useDetailsSortAndFilter = (props) => { 
    const{
        setRelatedSortOption,
        selectedSegment=0,
        relatedSortOption=[],
        setSelectedRelatedSortOption,
        setSortedRelatedValue,
        setSortValue=false,
        isConsignmentAdd=false,
        isSetDetail,
        initialList,
        isEquity,
        data,
        item
    } = props;

    const dispatch = useDispatch();
    const getSortOptionForRelatedProduct = () => {
        if (selectedSegment === '1' && relatedSortOption?.length === 0) {
            // eslint-disable-next-line no-unused-vars
            const { billOfMaterials, relatedProducts } = data;
            let options = [];
            relatedProducts.map((item) =>
                item.options.map((item) => options.push(item.optionValue))
            );
            let filterOption = [...new Set(options)];
            let relatedOption = filterOption.map((value) => {
                return {
                    id: value,
                    title: value,
                };
            });
            setRelatedSortOption(relatedOption);
            handleFilter(relatedOption[0].title);
            setSelectedRelatedSortOption(relatedOption[0].title);
        }
    };
  const handleFilter = (value) => {
        const handleItemFilter=()=>{
            if (selectedSegment === '0') {
                setSortValue(value);
                const object = {
                    data: data,
                    searchField:
                        value === '1' || value === '2' ? 'cfn' : 'description',
                    ascending: value === '1' || value === '3' ? true : false,
                };
                const foundInSets = sortSetItemDetails({
                    ...object,
                    objectField: 'foundInSets',
                });
                const sortedData = {
                    ...data,
                    foundInSets: foundInSets,
                };
                dispatch(
                    isEquity
                        ? sortEquityProductDetails(sortedData)
                        : isConsignmentAdd
                        ? sortConsignmentAddProductDetails(sortedData)
                        : sortProductDetails(sortedData)
                );
            } else {
                let sortRelatedProducts = [];
                setSelectedRelatedSortOption(value);
                (initialList?.relatedProducts ?? []).map((itemValue) =>
               (itemValue?.options ?? []).map((item) => {
                        if (item.optionValue === value) {
                            sortRelatedProducts.push(itemValue);
                        }
                    })
                );
                const sortedData = {
                    ...data,
                    relatedProducts: sortRelatedProducts,
                };
                dispatch(
                    isEquity
                        ? sortEquityProductDetails(sortedData)
                        : isConsignmentAdd
                        ? sortConsignmentAddProductDetails(sortedData)
                        : sortProductDetails(sortedData)
                );
            }
        };

         const handleSetsFilter=()=>{
            
            if (selectedSegment === '0') {
                        let sortBillOfMaterials = [];
                        setSortValue(value);
                        sortBillOfMaterials = sortSetItemDetails(
                            {
                                data: data,
                                objectField: 'billOfMaterials',
                                searchField:
                                    value === '1' || value === '2' ? 'bom' : 'description',
                                ascending: value === '1' || value === '3' ? true : false,
                            },
                            value === '1' || value === '2' ? true : false
                        );
                        const sortedData = {
                            ...data,
                            billOfMaterials: sortBillOfMaterials,
                        };
                        dispatch(
                            isEquity
                                ? sortEquityProductDetails(sortedData)
                                : isConsignmentAdd
                                ? sortConsignmentAddProductDetails(sortedData)
                                : sortProductDetails(sortedData)
                        );
                    } else {
                        let sortRelatedProducts = [];
                        setSelectedRelatedSortOption(value);
                        (initialList?.relatedProducts ?? []).map((itemValue) =>
                          (itemValue?.options ?? []).map((item) => {
                                if (item.optionValue === value) {
                                    sortRelatedProducts.push(itemValue);
                                }
                            })
                        );
            
                        const sortedData = {
                            ...data,
                            relatedProducts: sortRelatedProducts,
                        };
                        dispatch(
                            isEquity
                                ? sortEquityProductDetails(sortedData)
                                : isConsignmentAdd
                                ? sortConsignmentAddProductDetails(sortedData)
                                : sortProductDetails(sortedData)
                        );
                    }
        };
        
        isSetDetail? handleSetsFilter():handleItemFilter();
    };

    const handleListFilter = (value) => { 
        const sortItems=()=>{
            setSortValue(value);
            const object = {
                data: data,
                searchField: value === '1' || value === '2' ? 'cfn' : 'description',
                ascending: value === '1' || value === '3' ? true : false,
            };
            const foundInSets = sortSetItemDetails({
                ...object,
                objectField: 'foundInSets',
            });
            const sortedData = {
                ...data,
                foundInSets: foundInSets,
            };
            dispatch(
                isEquity
                    ? sortEquityProductDetails(sortedData)
                    : isConsignmentAdd
                    ? sortConsignmentAddProductDetails(sortedData)
                    : sortProductDetails(sortedData)
            );
            let sortRelatedProducts = [];
            setSortedRelatedValue(value);
          (initialList?.relatedProducts ?? []).map((itemValue) =>
              (itemValue?.options ?? []).map((item) => {
                    if (item.optionValue === value) {
                        sortRelatedProducts.push(itemValue);
                    }
                })
            );

        const sortedRelatedValue = {
            ...data,
            relatedProducts: sortRelatedProducts,
        };
        dispatch(
            isEquity
                ? sortEquityProductDetails(sortedRelatedValue)
                : isConsignmentAdd
                ? sortConsignmentAddProductDetails(sortedRelatedValue)
                : sortProductDetails(sortedRelatedValue)
        );
    };

        const sortSets=()=>{
            let sortBillOfMaterials = [];
                    setSortValue(value);
                    sortBillOfMaterials = sortSetItemDetails(
                        {
                            data: data,
                            objectField: 'billOfMaterials',
                            searchField:
                                value === '1' || value === '2' ? 'bom' : 'description',
                            ascending: value === '1' || value === '3' ? true : false,
                        },
                        value === '1' || value === '2' ? true : false
                    );
                    const sortedData = {
                        ...data,
                        billOfMaterials: sortBillOfMaterials,
                    };
                    dispatch(sortProductDetails(sortedData));
                    // } else {
                    let sortRelatedProducts = [];
                    setSortedRelatedValue(value);
                    (initialList?.relatedProducts ?? []).map((itemValue) =>
                    (itemValue?.options ?? []).map((item) => {
                            if (item.optionValue === value) {
                                sortRelatedProducts.push(itemValue);
                            }
                        })
                    );
            
                    const sortedRelatedValue = {
                        ...data,
                        relatedProducts: sortRelatedProducts,
                    };
                    dispatch(sortProductDetails(sortedRelatedValue));
        };

        isSetDetail ? sortSets():sortItems();
    };

    useEffectWithErrorLogging(() => {
        setSortValue('1');
    }, [item]);

    return {
        getSortOptionForRelatedProduct,
        handleFilter,
        handleListFilter 
    };
};

export default useDetailsSortAndFilter;